import { render } from "./PauseForm.vue?vue&type=template&id=517f58f8"
import script from "./PauseForm.vue?vue&type=script&lang=js"
export * from "./PauseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__